import * as React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress
} from '@mui/material';
import api from '../../../services/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { pt } from 'yup-locale-pt';
import { TextField, Autocomplete } from '../../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { participacaoOptions } from './static';

yup.setLocale(pt);

const DialogoEventos = ({ open, onClose, ano, empresa, selectedEvento }) => {
  let loading = useStoreState(state => state.nav.loading);
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const schema = yup
    .object({
      nomeEvento: yup.string().required().label('Nome do Evento'),
      participacao: yup
        .string()
        .required()
        .nullable()
        .label('Tipo de participação')
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const submit = async data => {
    startLoading();
    try {
      if (data.id) {
        await api.http.put('09/eventos/empresa/' + empresa + '/' + data.id, {
          ...data,
          ano
        });
      } else {
        await api.http.post('09/eventos/empresa/' + empresa, {
          ...data,
          ano
        });
      }
      stopLoading();
      close(true);
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const close = (reload = false) => {
    onClose(reload);
    reset({
      nomeEvento: null,
      participacao: null
    });
  };

  React.useEffect(() => {
    if (selectedEvento) {
      reset(selectedEvento);
    }
  }, [selectedEvento]);

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>Preencha os dados do Evento</DialogTitle>
      <DialogContent>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <TextField
            field="nomeEvento"
            schema={schema}
            useFormRef={useFormRef}
            margin="dense"
          />
        </FormControl>
        <FormControl sx={{ mb: 2 }} fullWidth>
          <Autocomplete
            field="participacao"
            options={participacaoOptions}
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        {loading > 0 && (
          <CircularProgress
            size={30}
            sx={{ position: 'absolute', left: 25, bottom: 12 }}
          />
        )}
        <Button color="inherit" onClick={() => close()}>
          CANCELAR
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit(submit)}
          disabled={!isDirty || isSubmitting}
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoEventos;
